var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.66525 1.5C14.1657 1.5 17.8305 5.16479 17.8305 9.66525C17.8305 11.6204 17.1447 13.413 15.9933 14.8196L22.5 21.3262L21.3262 22.5L14.8196 15.9933C13.413 17.1447 11.6204 17.8305 9.66525 17.8305C5.16479 17.8305 1.5 14.1657 1.5 9.66525C1.5 5.16479 5.16479 1.5 9.66525 1.5ZM9.66525 3.13305C6.0483 3.13305 3.13305 6.0483 3.13305 9.66525C3.13305 13.2822 6.0483 16.1974 9.66525 16.1974C13.2822 16.1974 16.1974 13.2822 16.1974 9.66525C16.1974 6.0483 13.2822 3.13305 9.66525 3.13305Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearch);
export default __webpack_public_path__ + "static/media/icon-search.085ee02228167d1698251d125110b02f.svg";
export { ForwardRef as ReactComponent };